import React from 'react';

const items = ['PAINTERS', 'ROOFERS', 'HVAC', 'PLUMBERS', 'ELECTRICIANS', 'LANDSCAPERS', 'REMODELERS', 'GARAGE DOORS'];

export default function TrustBar() {
  return (
    <section className="relative py-10 border-y border-[#e8e4d8] bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#6b6f6c] mb-6">Trusted by 120+ local service businesses</p>
        <div className="overflow-hidden">
          <div className="marquee flex whitespace-nowrap">
            {[...items, ...items, ...items].map((item, i) => (
              <div key={i} className="flex items-center gap-3 px-10">
                <div className="w-1.5 h-1.5 rounded-full bg-[#ea580c]" />
                <span className="font-display text-2xl font-semibold text-[#0b0f0d]/70">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
